<!--
 * @Author: 熊伟
 * @Date: 2026-01-15 11:10:29
 * @Description: 
 * @LastEditors: 熊伟
 * @LastEditTime: 2026-01-19 17:28:40
 * @FilePath: /tongliao-nethall-h5-standard/src/views/Home/module/waterUsageTermsPopup.vue
-->
<template>
  <div class="callPopup-page">
    <van-popup
      v-model="showWaterUsageTerms"
      round
      :closeable="false"
      :style="{ width: '80%' }"
      :close-on-click-overlay="false"
    >
      <div class="popup-content">
        <p>请确认个人信息</p>
        <p class="color-blue" @click="toTerms">《用水条款说明》</p>
      </div>
      <div class="btnContent">
        <span @click="confirm">同意</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'WaterUsageTermsPopup.vue',
  props: {
    showWaterUsageTerms: Boolean,
    default: () => {
      return false;
    }
  },
  data() {
    return {};
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    // 查看条款说明页面
    toTerms() {
      this.$router.push({ path: '/waterUsageTerms' });
    }
  }
};
</script>

<style lang="less" scoped>
.callPopup-page {
  // 弹出框
  .popup-content {
    padding-top: 15px;
    padding-bottom: 15px;
    p {
      margin: 0px;
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      color: #3f3f3f;
    }

    .color-blue {
      color: #0067e6;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
  .btnContent {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    span {
      font-size: 14px;
      width: 100%;
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: #0067e6;
    }
  }
}
</style>
